import React from "react";
import { map } from "lodash";

const thBase = "px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-700 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300";
const tdBase = "px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle";

export function FragmentTableGang({ gangs, updateGang, onDeleteGang }) {
  return (
    <>
      {/* Desktop table */}
      <div className="hidden md:block overflow-x-auto max-h-[70vh] overflow-y-auto bg-white dark:bg-gray-900">
        <table className="min-w-full text-sm border-separate border-spacing-0">
          <thead className="sticky top-0 z-10">
            <tr>
              <th className={thBase} rowSpan={2}>
                Nº
              </th>
              <th className={thBase} rowSpan={2}>
                Nombre Grupo
              </th>
              <th className={thBase} rowSpan={2}>
                Serie
              </th>
              <th className={thBase} colSpan={4}>
                <i className="fas fa-list-ol mr-2"></i>
                Correlativo
              </th>
              <th className={thBase} rowSpan={2}>
                <i className="fas fa-store mr-2"></i>
                Almacén
                <br />
                Autoventa
              </th>
              <th className={thBase} rowSpan={2}>
                <i className="fas fa-truck mr-2"></i>
                Almacén
                <br />
                Envíos
              </th>
              <th className={thBase} rowSpan={2}>
                Estado
              </th>
              <th className={thBase} rowSpan={2}>
                <i className="fas fa-users mr-2"></i>Integrantes
              </th>
              <th className={thBase} rowSpan={2}>
                Acción
              </th>
            </tr>
            <tr>
              <th className={thBase}>Preventa</th>
              <th className={thBase}>Ticket</th>
              <th className={thBase}>Boleta</th>
              <th className={thBase}>Factura</th>
            </tr>
          </thead>
          <tbody>
            {map(gangs, (gang, index) => (
              <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
                <td className={`${tdBase} text-blue-600 dark:text-blue-400 font-medium text-center`}>
                  {gang.gangID}
                </td>
                <td className={`${tdBase} text-center font-semibold text-gray-800 dark:text-gray-200`}>
                  {gang.gangName}
                </td>
                <td className={`${tdBase} text-center`}>{gang.serial}</td>
                <td className={`${tdBase} text-center`}>{gang.quotationCorrelative}</td>
                <td className={`${tdBase} text-center`}>{gang.ticketCorrelative}</td>
                <td className={`${tdBase} text-center`}>{gang.billCorrelative}</td>
                <td className={`${tdBase} text-center`}>{gang.invoiceCorrelative}</td>
                <td className={`${tdBase} text-center`}>{gang.warehouseName}</td>
                <td className={`${tdBase} text-center`}>{gang.shippingWarehouseName}</td>
                <td className={`${tdBase} text-center`}>
                  <div className="flex items-center justify-center">
                    <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                      <input
                        type="checkbox"
                        id={`switch${gang.gangID}`}
                        checked={gang.isEnabled}
                        readOnly
                        className="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 border-gray-300 appearance-none cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none"
                      />
                      <label
                        htmlFor={`switch${gang.gangID}`}
                        className={`toggle-label block overflow-hidden h-6 rounded-full cursor-pointer transition-colors ease-in-out duration-200 ${
                          gang.isEnabled ? "bg-blue-600" : "bg-gray-300"
                        }`}
                      ></label>
                    </div>
                    <span className={`text-xs font-medium ${
                      gang.isEnabled
                        ? "text-green-600 dark:text-green-400"
                        : "text-red-600 dark:text-red-400"
                    }`}>
                      {gang.isEnabled ? "Activo" : "Inactivo"}
                    </span>
                  </div>
                </td>
                <td className={`${tdBase}`}>
                  <ul className="space-y-1">
                    {gang.users.map((u, index) => (
                      <li
                        key={index}
                        value={u.userID}
                        className="text-xs text-gray-700 dark:text-gray-300 flex items-center gap-1 bg-gray-50 dark:bg-gray-700/50 px-2 py-1 rounded"
                      >
                        <i className="fas fa-user-circle"></i>
                        {u.userFullName}
                      </li>
                    ))}
                  </ul>
                </td>
                <Actions
                  gang={gang}
                  updateGang={updateGang}
                  onDeleteGang={onDeleteGang}
                />
              </tr>
            ))}

            {(!gangs || gangs.length === 0) && (
              <tr>
                <td colSpan={13} className="py-12 text-center text-sm text-gray-400 dark:text-gray-500">
                  No hay grupos para mostrar
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="md:hidden divide-y divide-gray-100 dark:divide-gray-700">
        {map(gangs, (gang, index) => (
          <div key={index} className="p-4">
            <div className="flex items-start justify-between mb-3">
              <div>
                <p className="text-sm font-semibold text-gray-900 dark:text-white">
                  <i className="fas fa-users mr-1 text-gray-400"></i>
                  {gang.gangName}
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                  Serie: {gang.serial}
                </p>
              </div>
              <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300">
                #{gang.gangID}
              </span>
            </div>

            <div className="grid grid-cols-1 gap-2 text-xs mb-3">
              <div className="flex justify-between items-center bg-gray-50 dark:bg-gray-700/50 rounded-lg px-3 py-1.5">
                <span className="text-gray-500 dark:text-gray-400">Almacén Autoventa</span>
                <span className="font-semibold text-gray-800 dark:text-gray-200">{gang.warehouseName}</span>
              </div>
              <div className="flex justify-between items-center bg-gray-50 dark:bg-gray-700/50 rounded-lg px-3 py-1.5">
                <span className="text-gray-500 dark:text-gray-400">Almacén Envíos</span>
                <span className="font-semibold text-gray-800 dark:text-gray-200">{gang.shippingWarehouseName}</span>
              </div>
              <div className="grid grid-cols-4 gap-2">
                <div className="flex flex-col items-center bg-gray-50 dark:bg-gray-700/50 rounded-lg px-2 py-1.5">
                  <span className="text-gray-500 dark:text-gray-400">Preventa</span>
                  <span className="font-semibold text-gray-800 dark:text-gray-200">{gang.quotationCorrelative}</span>
                </div>
                <div className="flex flex-col items-center bg-gray-50 dark:bg-gray-700/50 rounded-lg px-2 py-1.5">
                  <span className="text-gray-500 dark:text-gray-400">Ticket</span>
                  <span className="font-semibold text-gray-800 dark:text-gray-200">{gang.ticketCorrelative}</span>
                </div>
                <div className="flex flex-col items-center bg-gray-50 dark:bg-gray-700/50 rounded-lg px-2 py-1.5">
                  <span className="text-gray-500 dark:text-gray-400">Boleta</span>
                  <span className="font-semibold text-gray-800 dark:text-gray-200">{gang.billCorrelative}</span>
                </div>
                <div className="flex flex-col items-center bg-gray-50 dark:bg-gray-700/50 rounded-lg px-2 py-1.5">
                  <span className="text-gray-500 dark:text-gray-400">Factura</span>
                  <span className="font-semibold text-gray-800 dark:text-gray-200">{gang.invoiceCorrelative}</span>
                </div>
              </div>
              <div className="flex justify-between items-center bg-gray-50 dark:bg-gray-700/50 rounded-lg px-3 py-1.5">
                <span className="text-gray-500 dark:text-gray-400">Estado</span>
                <span className={`font-semibold ${
                  gang.isEnabled
                    ? "text-green-600 dark:text-green-400"
                    : "text-red-600 dark:text-red-400"
                }`}>
                  {gang.isEnabled ? "Activo" : "Inactivo"}
                </span>
              </div>
            </div>

            {gang.users.length > 0 && (
              <div className="mb-3">
                <p className="text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1">
                  Integrantes
                </p>
                <ul className="space-y-1">
                  {gang.users.map((u, index) => (
                    <li
                      key={index}
                      value={u.userID}
                      className="text-xs text-gray-700 dark:text-gray-300 flex items-center gap-1 bg-gray-50 dark:bg-gray-700/50 px-2 py-1 rounded"
                    >
                      <i className="fas fa-user-circle"></i>
                      {u.userFullName}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => updateGang(gang)}
                className="flex-1 inline-flex items-center justify-center gap-1 rounded-lg border border-amber-300 dark:border-amber-700 text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 text-sm font-medium px-3 py-2 transition-colors"
              >
                <i className="fas fa-edit"></i>
                Editar
              </button>
              <button
                type="button"
                onClick={() => onDeleteGang(gang)}
                className="flex-1 inline-flex items-center justify-center gap-1 rounded-lg border border-red-300 dark:border-red-700 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 text-sm font-medium px-3 py-2 transition-colors"
              >
                <i className="fas fa-trash-alt"></i>
                Eliminar
              </button>
            </div>
          </div>
        ))}

        {(!gangs || gangs.length === 0) && (
          <div className="py-12 text-center text-sm text-gray-400 dark:text-gray-500">
            No hay grupos para mostrar
          </div>
        )}
      </div>
    </>
  );
}

function Actions({ gang, updateGang, onDeleteGang }) {
  return (
    <td className={`${tdBase} text-center`}>
      <div className="flex items-center justify-center gap-1">
        <button
          type="button"
          onClick={() => updateGang(gang)}
          className="inline-flex items-center gap-1 rounded-md border border-amber-300 dark:border-amber-700 text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 text-xs font-medium px-2 py-1 transition-colors"
        >
          <i className="fas fa-edit"></i>
        </button>
        <button
          type="button"
          onClick={() => onDeleteGang(gang)}
          className="inline-flex items-center gap-1 rounded-md border border-red-300 dark:border-red-700 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 text-xs font-medium px-2 py-1 transition-colors"
        >
          <i className="fas fa-trash-alt"></i>
        </button>
      </div>
    </td>
  );
}
